import { render, staticRenderFns } from "./AccountDriverDetails.vue?vue&type=template&id=bb692388&"
import script from "./AccountDriverDetails.vue?vue&type=script&lang=js&"
export * from "./AccountDriverDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports